module.exports = __webpack_public_path__ + "static/Jeff-Potter-9467eb807a77dfc1dd877c8155940972.jpg";